import { filter, map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { SymbolClientAction } from '@cbridge-packages/symbol-client';

export const handleSymbolClientNotFoundEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.load.failed),
  filter(({ error }) => error.status === 404),
  map(() => DetailsSidebarAction.close()),
);
